import classNames from 'classnames';
import React from 'react';
import globalCss from '../../css/global.module.scss';
import { maskValue } from '../../helpers/maskValue';
import css from './DataBox.module.scss';
import { GMBox } from '../Box';

export type DataBoxItem =
    | {
        title: string;
        value?: string;
        valueIcon?: JSX.Element;
        case?: 'capitalize' | 'uppercase' | 'lowercase';
        masked?: boolean;
    }
    | 'spacer';

interface IDataBoxProps {
    dataItems?: DataBoxItem[];
    className?: string;
}

export const DataBox = React.memo((props: IDataBoxProps) => (
    <GMBox color={'primary'}>
        <div className={classNames(css.dataBox, props.className)}>
            {props.dataItems?.map((item, index) => {
                if (item === 'spacer') {
                    return (
                        <div key={'spacer' + index.toString()} className={css.dataItem}>
                            <div>&nbsp;</div>
                        </div>
                    );
                }
                else {
                    return (
                        <div key={item.title + index.toString()} className={css.dataItem}>
                            <div className={css.doNotBreakWords}>{item.title}</div>
                            <div
                                className={classNames(css.breakWords, {
                                    [globalCss.capitalize]: item.case === 'capitalize',
                                    [globalCss.uppercase]: item.case === 'uppercase',
                                    [globalCss.lowercase]: item.case === 'lowercase',
                                    [css.dataBoxValue]: true,
                                })}
                            >
                                {item.masked
                                    ? maskValue(item.case ? item.value?.toLocaleLowerCase() : item.value)
                                    : item.case
                                        ? item.value?.toLocaleLowerCase()
                                        : item.value}
                                {item.valueIcon ? <div>{item.valueIcon}</div> : null}
                            </div>
                        </div>
                    );
                }
            })}
        </div>
    </GMBox>
));
